import { render, staticRenderFns } from "./SaleExecutive.vue?vue&type=template&id=5f563911&scoped=true&"
import script from "./SaleExecutive.vue?vue&type=script&lang=js&"
export * from "./SaleExecutive.vue?vue&type=script&lang=js&"
import style0 from "./SaleExecutive.vue?vue&type=style&index=0&id=5f563911&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f563911",
  null
  
)

export default component.exports